interface GeneratedSuccessfullyProps {
  generatedSuccessfully?: string;
}

export class GenerateTagDataParams {
  static param: GeneratedSuccessfullyProps;
}
